<form [formGroup]="form" style="flex-direction: column; display: flex">
  <mat-form-field appearance="outline">
    <mat-select
      formControlName="{{ control }}"
      [multiple]="true"
      #interestControl
    >
      <mat-select-search
        [formControl]="bankMultiFilterCtrl"
        noEntriesFoundLabel="Results no found"
        [placeholderLabel]="placeholderLabel"
      >
      </mat-select-search>
      <mat-option
        *ngFor="let option of filteredBanksMulti | async"
        [value]="option"
        #interestControl
        [disabled]="
          form.get(control).value.length > 5 && !interestControl.selected
        "
      >
        {{ val2complete ? option[val2complete] : (option | capitalLetter) }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
